import { type PollingSchedule } from './feed.js';
import { type Kind as ApiInstanceKind } from './orchestrator/apiInstance.js';

export enum ConnectionType {
  Sftp = 'Sftp',
  Api = 'Api',
  InterfaceEngine = 'InterfaceEngine',
}

export enum ApiInstanceMode {
  Test = 'Test',
  Production = 'Production',
}

export enum FeedStatus {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}
export interface Connection {
  connectionType: ConnectionType;
  connectionId: string;
  name: string;
  source: string;
  destination: string;
  /**
   * FIXME - this field is in flux, and we are adjusting APIs during discovery phase
   * It will be standardized by 2025-12-31 or so.
   */
  method: string;
  /**
   * FIXME - this field is in flux, and we are adjusting APIs during discovery phase
   * It will be standardized by 2025-12-31 or so.
   */
  dataType: string;
  organizationId: string;
  lastUpdated: string;
  detailPath: string;
  lastActivityAt: string | null;
}

export type ConnectionSftp = Omit<Connection, 'connectionType' | 'lastUpdated'> & {
  connectionType: ConnectionType.Sftp;
  // created at timestamp
  created: string;
  // updated at timestamp
  updated: string;
  status: FeedStatus;
  filePath: string;
  pollingSchedule?: PollingSchedule;
  practiceIds: string[];
  flowIds: string[];
};

export type ConnectionApi = Omit<Connection, 'connectionType' | 'lastUpdated'> & {
  connectionType: ConnectionType.Api;
  // created at timestamp
  created: string;
  // updated at timestamp
  updated: string;
  deploymentName: string;
  clientId: string;
  kind: ApiInstanceKind;
  baseUrl: string;
  authenticationUrl: string;
  mrnURI: string | null;
  mode: ApiInstanceMode;
};

export type ConnectionInterfaceEngine = Omit<Connection, 'connectionType' | 'lastUpdated'> & {
  connectionType: ConnectionType.InterfaceEngine;
  port: string;
  // updated at timestamp
  updated: string;
  feedId: string | null;
  flowIds: string[];
};

export interface FindAllOptions {
  source?: string;
  destination?: string;
  connectionType?: ConnectionType;
  dataType?: string;
  organizationId?: string;
  method?: string;
  q?: string;
}
